import React from "react";
import Layout from "../../components/layout/layout";
import styles from "./index.module.scss";
import Content from "../../components/content/content";
import Contact from "../../components/contact/contact";

const Benefits = () => {
  const benefit_a = {
    benefitTitle: "Benefits for your Community",
    benefitLists: [
      "Easy-to-use templates",
      "GIS Import and map drawing tools",
      "Packed full of map layers",
      "24/7 Access for emergency response teams",
      "Planning team collaboration",
      "Manage the  privacy settings for your data",
    ],
    src: "benefit_02",
    layout: "layoutB",
  };
  const benefit_b = {
    benefitTitle: "Benefits for Emergency Response Teams",
    benefitLists: [
      "Online, centralized repository of plans",
      "Augments existing tools",
      "Based upon ‘Developing a Wildfire Preparedness Guide’, by Agriculture and Forestry, Government of Alberta",
      "Consistent Plans",
      "Planning Team Collaboration",
    ],
    src: "benefit_03",
    layout: "layoutA",
    background: true,
  };
  const benefit_c = {
    benefitTitle: "Benefits for Contractors",
    benefitLists: [
      "Access to community Structural Protection data (historical and current)",
      "Access to FireSmart treatment data",
      "Access to Historical Plans",
      "Exports Geo-Referenced PDF Map for use in other tools",
      "GIS Import and Map Drawing Tools",
      "FireWeb and Altalis™ data included",
      "Timing lags are minimized because communities can initiate plans on their own",
    ],
    src: "benefit_04",
    layout: "layoutB",
  };

  return (
    <Layout>
      <div className={styles.wrapper}>
        <section className={styles.heroWrap}>
          <div className={styles.container}>
            <div className={styles.heroContent}>
              <h2 className={styles.title}>Benefits</h2>
              <h5>
                Built for communities, the Hub benefits everyone involved.
              </h5>
            </div>
            <div className={styles.heroGraphic}></div>
          </div>
        </section>

        <Content {...benefit_a} />
        <Content {...benefit_b} />
        <Content {...benefit_c} />
      </div>
      <Contact />
    </Layout>
  );
};

export default Benefits;
